import { render, staticRenderFns } from "./account-container.vue?vue&type=template&id=f25e0c5c"
import script from "./account-container.vue?vue&type=script&lang=js"
export * from "./account-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports